<template>
    <div id="view1" style="min-width:400px;height:400px"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
    data() {
        return {
            myChart: null,
            isshow: false
        };
    },
    methods: {
        screenWidth() {
            this.myChart.resize();
        },
        getData(date, data) {
            if (this.isshow) {
                return this.screenWidth();
            }
            this.isshow = true;
            this.viewCharts(date, data);
        },
        viewCharts(date, data) {
            this.myChart = echarts.init(document.getElementById("view1"));
            let option = {
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    borderColor: "rgba(0, 0, 0, 0.6)",
                    textStyle: {
                        color: "rgb(255, 255, 255)"
                    },
                    axisPointer: {
                        animation: false
                    }
                },
                title: {
                    text: "$",
                    textStyle: {
                        color: "#aaa",
                        fontStyle: "normal",
                        fontSize: "12",
                        lineHeight: 50
                    },
                    left: "2%"
                },
                grid: {
                    left: "2.5%",
                    right: "2.5%"
                },
                xAxis: {
                    type: "category",
                    data: date
                },
                yAxis: {
                    type: "value"
                },
                dataZoom: [
                    {
                        type: "inside",
                        start: 80,
                        end: 100
                    },
                    {
                        start: 80,
                        end: 100
                    }
                ],
                series: [
                    {
                        name: "价格：",
                        type: "line",
                        data: data,
                        showAllSymbol: false,
                        itemStyle: {
                            color: "rgb(204, 44, 35)"
                        },
                        lineStyle: {
                            color: "rgb(204, 44, 35)"
                        },
                        emphasis: {
                            lineStyle: {
                                width: 2
                            }
                        }
                    }
                ]
            };
            // 绘制图表
            this.myChart.setOption(option);
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
</style>
